import { render, staticRenderFns } from "./zhengwu.vue?vue&type=template&id=0a280f30&scoped=true&"
import script from "./zhengwu.vue?vue&type=script&lang=js&"
export * from "./zhengwu.vue?vue&type=script&lang=js&"
import style0 from "./zhengwu.vue?vue&type=style&index=0&id=0a280f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a280f30",
  null
  
)

export default component.exports